// Firebase client singletons for usersmatch-pwa. Built from this app's own
// project config via the shared @upadelmatch/core factory — same construction
// (persistent multi-tab cache, europe-west1 functions, in-memory fallback) as
// clubmanager, just a different project. Also binds the shared Firestore
// repository base to this app's db + logger (configureFirestore) so any
// repository extending @upadelmatch/core's FirestoreRepository works here.
import { createFirebaseClient, configureFirestore, logger } from '@upadelmatch/core'
import { firebaseConfig, env } from './config'

const client = createFirebaseClient(firebaseConfig)

export const app = client.app
export const auth = client.auth
export const db = client.db
export const functions = client.functions
export { env }

configureFirestore({ db, logger })
